import { Component, Prop, Event, EventEmitter, Method, State, Element, h } from '@stencil/core';
import { Color, Size } from '../../interface';
import { DataIn } from './weather-interface';

@Component({
  tag: 'lar-weather',
  shadow: true
})
export class Weather {
  @Element() el!: HTMLLarWeatherElement;

  /////// LarvaNode base properties
  /**
   * Component main icon
   */
  @Prop({ mutable: true }) icon?: string = 'cloud';
  /**
   * The color to use from your application's color palette.
   * Detrouble options are: `"primary"`, `"secondary"`, `"tertiary"`, `"success"`, `"warning"`, `"danger"`, `"light"`, `"medium"`, and `"dark"`.
   */
  @Prop({ mutable: true }) color?: Color = 'primary';
  /**
   * The color to use from your application's color palette for Components modal window.
   */
  @Prop({ mutable: true }) colorModal?: Color;
  /**
   * The color to use from your application's color palette for inputs
   */
  @Prop({ mutable: true }) colorInputs?: Color;
  /**
   * The color to use from your application's color palette for indication icon
   */
  @Prop() colorIconSmall?: Color;
  /**
   * Hide node titles
   */
  @Prop() hideTitles?: boolean;
  /**
   * Component superscript title
   */
  @Prop() supTitle?: string;
  /**
   * Component subtitle
   */
  @Prop() subTitle?: string;
  /**
   * Is logging for this component enabled (lar-log subcomponent loaded)
   */
  @Prop() log: boolean = false;
  /**
   * Component main title
   */
  @Prop() mainTitle!: string;
  /**
   * Node size
   */
  @Prop() nodeSize?: Size = 'default';
  /**
   * @see {@link ../readme.md} chapter "Components input and output" for further information.
   */
  @Event() output!: EventEmitter;
  /**
   * @see {@link ../readme.md} chapter "Sub-Components requests and responses" for further information.
   */
  @Event() request!: EventEmitter;
  /////// LarvaNode base properties and events - end

  @State() dataIn: DataIn = {};
  @State() loading: boolean = true;

  private node!: HTMLLarNodeElement;

  componentDidLoad() {
    const el = this.el.shadowRoot || this.el;
    this.node = el.querySelector('lar-node') as HTMLLarNodeElement;
    this.output.emit();
  }
  /**
   * Larva error input
   */
  @Method()
  async error(data: any) {
    if (this.node) {
      this.node.error(data);
    }
    this.loading = false;
  }
  /**
   * Input Larva event message (see abow)
   */
  @Method()
  async input(data: DataIn) {
    this.loading = false;
    this.dataIn = data;
 }

  render() {
    const compnentProps = {
      data: this.dataIn,
    };
    const value = this.dataIn.temperature !== undefined ? `${String(this.dataIn.temperature)}°`: null;
    const icon = this.dataIn.icon ? this.dataIn.icon : this.icon;
    return [
      <lar-node
        icon={icon}
        hideTitles={this.hideTitles}
        color={this.color}
        supTitle={this.supTitle}
        mainTitle={this.mainTitle}
        subTitle={this.subTitle}
        colorModal={this.colorModal}
        colorInputs={this.colorInputs}
        colorIconSmall={this.colorIconSmall}
        log={this.log}
        value={value}
        loading={this.loading}
        nodeSize={this.nodeSize}
        component="lar-weather-content"
        componentProps={compnentProps}
      >
        <slot />
      </lar-node>
    ];
  }
}
